var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.view
    ? _c("transition", { attrs: { name: "modal" } }, [
        _c("div", [
          _c("div", { staticClass: "modal-mask" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-container" },
            [
              _c("div", { staticClass: "modal-close" }, [
                _c("img", {
                  staticStyle: { width: "20px", height: "20px" },
                  attrs: { src: "/dist/btnClose.png" },
                  on: {
                    click: function($event) {
                      _vm.$store.commit("modal/close")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(_vm.view, { tag: "component" })
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1adac4da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adac4da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1adac4da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/modal.vue
// module chunks = 0